import { render, staticRenderFns } from "./EditPatient.vue?vue&type=template&id=b2b05214&scoped=true"
import script from "./EditPatient.vue?vue&type=script&lang=js"
export * from "./EditPatient.vue?vue&type=script&lang=js"
import style0 from "./EditPatient.vue?vue&type=style&index=0&id=b2b05214&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b05214",
  null
  
)

export default component.exports